'use strict';

angular.module('theme').component('copyCampaignCode', {
	templateUrl: 'component/copy-campaign-code.html',
	bindings: {
		code: '<'
	},
	controller: function($timeout) {
		var self = this;

		console.log(self.code);

		this.copyTextToClipboard = function(text) {
			var textArea = document.createElement('textarea');
			textArea.value = text;
			textArea.style.top = '0';
			textArea.style.left = '0';
			textArea.style.position = 'fixed';

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				document.execCommand('copy');
				self.showToolTip = true;
				$timeout(function() {
					self.showToolTip = false;
				}, 3000);
			} catch(err) {
				console.log(err);
			}

			document.body.removeChild(textArea);
		};

		this.copyCode = function(e) {
			e.preventDefault();
			self.copyTextToClipboard(self.code);
		};

	}
});
